module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("2d5pg"))).then(() => parcelRequire('f4eak'));